import { Reducer } from 'redux';
import { KnownAction } from './userActions';
import { UserState } from './userModels';

/* tslint:disable */
// ----------------
// REDUCER - For a given state and action, returns the new state.
// To support time travel, this must not mutate the old state.
export const reducer: Reducer<UserState> = (state: UserState, action: KnownAction) => {
    if (state === null || state === undefined) {
        state = {
            permissions: {
                duct: {
                    create: false,
                    read: false,
                    update: false
                },
                invoices: {
                    create: false,
                    read: false,
                    update: false
                },
                news: {
                    create: false,
                    read: false,
                    update: false
                },
                opportunities: {
                    create: false,
                    read: false,
                    update: false
                },
                orders: {
                    create: false,
                    read: false,
                    update: false
                },
                quickTickOnline: {
                    create: false,
                    read: false,
                    update: false
                },
                resourceTraining: {
                    create: false,
                    read: false,
                    update: false
                },
                fullAccess: {
                    create: false,
                    read: false,
                    update: false
                }, 
                qfv: {
                    create: false, 
                    read: false, 
                    update: false
                }
            },
            firstName: '',
            lastName: '',
            token: 'no token',
            name: 'John Smith',
            contactEmailAddress: '',
            crmUserId: '',
            error: false,
            errorMessage: '',
            CustomerInformation: {
                salesCurentYearToDate: 0,
                salesPreviousYear: 0,
                salesPreviousYearToDate: 0,
                ranking: -1,
                territoryName: ''
            }
        };
    }

    switch (action.type) {
        case 'SET_TOKEN':
            return Object.assign({}, state, { token: action.data });
        case 'SET_USER_NAME':
            return Object.assign({}, state, { name: action.data });
        case 'SET_FIRST_NAME':
            return Object.assign({}, state, { firstName: action.firstName });
        case 'SET_LAST_NAME':
            return Object.assign({}, state, { lastName: action.lastName });
        case 'SET_CONTACT_EMAIL':
            return Object.assign({}, state, { contactEmailAddress: action.contactEmailAddress });
        case 'SET_CRM_USER_ID':
            return Object.assign({}, state, { crmUserId: action.crmUserId });
        case 'SET_ERROR':
            return Object.assign({}, state, { error: action.error });
        case 'SET_ERROR_MESSAGE':
            return Object.assign({}, state, { errorMessage: action.errorMessage });
        case 'SET_PERMISSIONS':
            return Object.assign({}, state, { permissions: action.data });
        case 'SET_CUSTOMERDATA':
            return Object.assign({}, state, { CustomerInformation: action.customerData });
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/data/user/userReducers.ts